// First-party, consent-gated analytics.
// Reads the cookie-consent choice from localStorage and only pings the
// backend when the listener has chosen "all". Fails silently — never
// blocks or slows the UI. No cookies, no cross-site tracking, no PII.

const KEY = "christovibes:cookie_consent:v1";
const API = `${process.env.REACT_APP_BACKEND_URL || ""}/api/analytics/event`;

function getConsent() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed?.choice || null;
  } catch {
    return null;
  }
}

export function analyticsEnabled() {
  return getConsent() === "all";
}

export function track(event, props) {
  const consent = getConsent();
  if (consent !== "all") return; // honour the listener's choice
  try {
    const body = JSON.stringify({
      event,
      platform: "web",
      consent,
      props: props || {},
    });
    // Prefer sendBeacon for reliability during page unload; fall back to fetch.
    if (typeof navigator !== "undefined" && navigator.sendBeacon) {
      const blob = new Blob([body], { type: "application/json" });
      navigator.sendBeacon(API, blob);
    } else {
      fetch(API, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body,
        keepalive: true,
      }).catch(() => {});
    }
  } catch {
    /* swallow — analytics must never break the app */
  }
}
